export const PERFORMANCE_IFRAME_HEIGHT: number = 1550
